const translator = {
  esp: 'Traduko: T. Auderskaja'
}; 
export default translator;